import * as sonbp from "sonbp";
import * as ifbase from "./base";
import { drawCommon } from "./listener";

// --------------------------------------------------
// 動作設定
// --------------------------------------------------

// 設定の上書き
export var bpSettingOverwrite = function (ifdto: ifbase.ifDto) {

	let bpView = ifdto.bpView;

	// --------------------------------------
	// viewの起動オプション設定
	// --------------------------------------

	// [sonbp] 描画領域中のページ初期配置位置設定
	bpView.expression.defaultPositionType = sonbp.constant.pivot.CENTER_MIDDLE;
	bpView.expression.defaultPositionPadding = 0;

	if (ifdto.pageOffset) {
		bpView.expression.defaultPositionAdjust = [ifdto.pageOffset.x, ifdto.pageOffset.y];
	}

	// [sonbp] 描画領域の最小・最大 スケール 設定
	// 表示として許容する最小・最大値について、100% = 1.0 として設定します。
	bpView.expression.minScale = 0.1;
	bpView.expression.maxScale = 50.0;

	//bpView.expression.docUnit = sonbp.constant.unit.MM;

	// [sonbp] 描画領域の表示ページ数
	bpView.expression.pageCount = 1;
	// [sonbp] ページ表示方向
	bpView.expression.pageFlow = sonbp.constant.documentFlow.RIGHT2LEFT;
	// [sonbp] 座標基準
	bpView.expression.basePoint = sonbp.constant.pointBase.LEFTBOTTOM;		//sonbp.constant.pointBase.LEFTTOP;		ポスカ業務との連携は左下基準

	////// [sonbp] テキストアイテムの初期フォント
	////own.bpView.initialize.prgFontName = "ＭＳ 明朝 標準";
	////// [sonbp] テキストアイテムの初期文字サイズ
	////own.bpView.initialize.prgFontSize = 10;
	// [sonbp] 編集カラーの初期タイプ
	bpView.initialize.colorType = "cmyk";

	// --------------------------------------
	// 操作設定画面の初期値
	// --------------------------------------

	// [sonbp] 描画領域の表示ページ数
	bpView.expression.pageCount = 1;
	// [sonbp] 描画解像度の固定値（dpi）
	bpView.expression.monitorDpi = 72;

	// [sonbp] ビューア/エディタが扱う単位情報（一般的な単位）の設定
	bpView.expression.docUnit = sonbp.constant.unit.PT;					//sonbp.constant.unit.MM;	ポスカ業務との連携はPT単位
	// [sonbp] ビューア/エディタが扱う単位情報（テキスト単位）の設定
	bpView.expression.textUnit = sonbp.constant.unit.PT;
	// ビューア/エディタが扱う単位情報（ライン単位）
	bpView.expression.lineUnit = sonbp.constant.unit.PT;	//sonbp.constant.unit.MM;

	// SPモードならタッチ操作ビュー
	bpView.expression.viewForTouch = (): boolean => {
		if (ifdto.client == ifbase.constants.CLIENT_SP) {
			return true;
		}
		return false;
	};

	// [sonbp] 編集カラーの初期タイプ
	bpView.initialize.colorType = sonbp.constant.colorType.CMYK;

	// [sonbp] ガイドライン表示有無
	bpView.style.isDrawSnapLine = false;

	// --------------------------------------
	// アイテム作成時の初期値
	// --------------------------------------

	// [sonbp] テキストアイテムの初期フォント
	bpView.initialize.prgFontName = "ＭＳ ゴシック 標準";

	// [sonbp] テキストアイテムの初期文字サイズ（PT指定）
	bpView.initialize.prgFontSize = 9;

	// [sonbp] 線幅の初期サイズ（PT指定）
	bpView.initialize.lineWidth = 10;

	// [sonbp] 図形の描画モード（S：線のみ｜s：クローズ線｜f：塗りつぶしのみ｜B：塗りつぶし＆線）
	bpView.initialize.pathRenderMode = "B";

	// [sonbp] アスペクト比固定
	bpView.initialize.isAspectNg = true;

	// --------------------------------------
	// アイテム矩形描画
	// --------------------------------------

	//画像枠
	bpView.style.clipLineStyle = "rgba(221, 98, 28 ,0.8)";
	bpView.style.clipLineBorderWidth = 3;
	bpView.style.clipLineDash = [8, 4];

	//選択アイテム
	bpView.style.selectLineStyle = "rgba(221, 98, 28 ,0.8)";
	///bpView.style.editHandleFillStyle = "rgba(255, 55, 0 ,0.1)";
	bpView.style.editHandleFillStyle = "rgba(255, 255, 255 ,1.0)";
	bpView.style.selectLineBorderWidth = 3;
	bpView.style.selectLineDash = [8, 4];

	//未選択アイテム
	bpView.style.selectCandiLineStyle = "rgba(200, 200, 200 ,0.8)";
	bpView.style.selectCandiLineBorderWidth = 3;
	bpView.style.selectCandiLineDash = [4, 3];

	// --------------------------------------
	// ページ付属描画
	// --------------------------------------
	bpView.style.pageBoxDrawType = 0;
	bpView.style.isDrawPageExtension = false;
	//bpView.style.isDrawPageBackground = false;

	// --------------------------------------
	// インラインテキスト未使用
	// --------------------------------------

	//フォントキャッシュ未使用
	bpView.efficiency.useMjCache = false;

	// -----------------------------------------------
	// レイヤー補助描画
	// -----------------------------------------------

	/**
	 * Layer における補助情報の描画
	 */
	bpView.style.drawLayerExtention = (v: sonbp.view, ctx: CanvasRenderingContext2D, pageIdx: number, layerIdx: number, isCapture: boolean) => {

		if (ifbase.util.chkIsPhotoManiInSP(ifdto)) {
			//SPモードでの写真操作中は非表示
			return;
		}

		let layer = v._om._doc.pages[pageIdx].layers[layerIdx];

		//画像レイヤーの場合
		if (layer.info.vendor_property.ffpsc?.layer_type == ifbase.constants.LTYPE_PHOTO) {

			let items = ifbase.util.getItems(layer.items, function (item: sonbp.object.baseItem): boolean {
				return item.info.vendor_property.ffpsc?.item_type == ifbase.constants.ITYPE_PHOTO_BOX;
			});

			ctx.save();
			v._dm.pageTransform(0, ctx);

			for (let i = 0; i < items.length; i++) {
				let box = items[i] as sonbp.object.groupItem;

				// 未配置画像枠ならアイコン表示
				// ※スタンプより下に描画の必要あるためdrawLayerExtentionで描画
				if (box.childs[0].info.vendor_property.ffpsc?.file_id == "@DUMMY@") {
					drawCommon.drawBlankBoxIcon(v, ctx, box);
				}
			}

			ctx.restore();
		}
	}
}
